import type { SVGProps } from "react";

export const TVIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className="fill-current"
      {...props}
    >
      <path
        d="M15.2197 3.96973C15.5126 3.67683 15.9874 3.67683 16.2803 3.96973C16.5731 4.26262 16.5731 4.7374 16.2803 5.03027L13.8105 7.5H18C19.2426 7.5 20.25 8.50736 20.25 9.75V18C20.25 19.2426 19.2426 20.25 18 20.25H6C4.75736 20.25 3.75001 19.2426 3.75 18V9.75C3.75 8.50736 4.75736 7.5 6 7.5H10.1895L7.71973 5.03027C7.42683 4.73738 7.42684 4.26262 7.71973 3.96973C8.01262 3.67683 8.48738 3.67683 8.78027 3.96973L12 7.18945L15.2197 3.96973ZM6 9C5.58579 9 5.25 9.33579 5.25 9.75V18C5.25001 18.4142 5.58579 18.75 6 18.75H18C18.4142 18.75 18.75 18.4142 18.75 18V9.75C18.75 9.33579 18.4142 9 18 9H6Z"
        fill="currentColor"
      />
    </svg>
  );
};
